export default class ExpectedErrorResponseError extends Error {
  constructor(message, rawResponse = {}) {
    super(message);
    this.rawResponse = { ...rawResponse };
  }
}
